import { render, staticRenderFns } from "./CouponForBundlePromotionCreateForm.vue?vue&type=template&id=686cb598&"
import script from "./CouponForBundlePromotionCreateForm.vue?vue&type=script&lang=js&"
export * from "./CouponForBundlePromotionCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports